import keyMirror from 'keymirror';

export const ResetPasswordActionTypes = keyMirror({
  RESET_PASSWORD: undefined,
  RESET_PASSWORD_SUCCESS: undefined,
  RESET_PASSWORD_ERROR: undefined,
  RESET_PASSWORD_CLEAR: undefined,
});
